// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { getProfile } from './userThunk';
import { RootState } from '~/utils/redux/store';
import { IProfile } from '~/utils/interface/user';
import { GoogleConnectEnum, QuickBookConnectEnum } from '~/utils/enum/common';

export interface UserState {
  profile: IProfile;
  isRefreshProfile: boolean;
}

const initialState: UserState = {
  profile: {} as IProfile,
  isRefreshProfile: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setRefreshProfile(state, action) {
      state.isRefreshProfile = action.payload;
    },
    disconnectedGoogle(state) {
      if (state.profile) {
        if (!state.profile.google) {
          state.profile.google = { status: GoogleConnectEnum.DISCONNECTED };
        } else {
          state.profile.google.status = GoogleConnectEnum.DISCONNECTED;
        }
      }
    },
    connectedGoogle(state) {
      if (state.profile) {
        if (!state.profile.google) {
          state.profile.google = { status: GoogleConnectEnum.CONNECTED };
        } else {
          state.profile.google.status = GoogleConnectEnum.CONNECTED;
        }
      }
    },
    disconnectedQuickBook(state) {
      if (!state.profile.quickBook) {
        state.profile.quickBook = { status: QuickBookConnectEnum.DISCONNECTED };
      }
      state.profile.quickBook.status = QuickBookConnectEnum.DISCONNECTED;
    },
    connectedQuickBook(state) {
      if (!state.profile.quickBook) {
        state.profile.quickBook = { status: QuickBookConnectEnum.CONNECTED };
      }
      state.profile.quickBook.status = QuickBookConnectEnum.CONNECTED;
    },
  },
  extraReducers(builder) {
    // GET: Get customer list
    builder
      .addCase(getProfile.pending, (_state) => {})
      .addCase(getProfile.fulfilled, (state, action) => {
        state.profile = action.payload.data;
      })
      .addCase(getProfile.rejected, (_state) => {});
  },
});

// Action
export const userActions = userSlice.actions;

// Selectors
export const selectProfile = (state: RootState) => state.user.profile;
export const selectIsRefreshProfile = (state: RootState) => state.user.isRefreshProfile;

// Reducer
const userReducer = userSlice.reducer;
export default userReducer;
